import lang from "../../../Translation/Ladning.json";

const NetPayment = ({ data = [] }) => {
  const text = lang.NetPayment;

  // ✅ Step 1: Keep only the latest record for each unique unitNumber
  const latestByUnit = Object.values(
    data.reduce((acc, item) => {
      const unit = item.unitNumber;
      const existing = acc[unit];

      if (
        !existing ||
        new Date(item.receiptDate) > new Date(existing.receiptDate)
      ) {
        acc[unit] = item;
      }

      return acc;
    }, {})
  );

  // ✅ Step 2: Group by zone (each unit counts once)
  const zoneTotals = latestByUnit.reduce((acc, item) => {
    const zoneKey = item.zone?.toLowerCase(); // e.g., "zone3"
    if (!zoneKey) return acc;
    acc[zoneKey] = (acc[zoneKey] || 0) + (item.paymentAmount || 0);
    return acc;
  }, {});

  // ✅ Step 3: Calculate total and zone percentages
  const totalNetPayment = Object.values(zoneTotals).reduce((a, b) => a + b, 0);

  const zonePercentages = Object.entries(zoneTotals).map(([zone, amount]) => ({
    name: zone.replace("zone", "Zone "),
    percentage: totalNetPayment
      ? Math.round((amount / totalNetPayment) * 100)
      : 0,
  }));

  // ✅ Step 4: Count unique units
  const uniqueUnits = latestByUnit.length;

  // ✅ Step 5: Get latest date
  const latestDate =
    latestByUnit.length > 0
      ? new Date(
          Math.max(...latestByUnit.map((item) => new Date(item.receiptDate)))
        ).toLocaleDateString("en-GB")
      : "-";

  // ✅ Step 6: Render
  return (
    <div className="p-5 rounded-md border shadow-md bg-white">
      {/* Header Section */}
      <div>
        <h2 className="text-xl mb-1 font-semibold uppercase text-blue-800">
          {text.title}
        </h2>

        <p className="text-lg mb-2 text-blue-700 font-medium">
          {text.amount}:{" "}
          <span className="text-xl ms-1 font-semibold text-gray-900">
            RM {Number(totalNetPayment).toLocaleString(undefined, {
              minimumFractionDigits: 2,
            })}
          </span>
        </p>

        <p className="text-lg text-gray-700">
          {text.number_of_units}:{" "}
          <span className="text-xl font-semibold text-gray-900">
            {uniqueUnits.toLocaleString()} {text.unit}
          </span>
        </p>
      </div>

      <hr className="my-4 border-gray-400" />

      {/* Progress Bars */}
      <div className="space-y-4">
        {zonePercentages.map((zone, index) => (
          <div key={index}>
            <div className="flex justify-between items-center mb-1">
              <p className="text-lg font-medium text-gray-800">{zone.name}</p>
              <p className="text-sm font-semibold text-gray-700">
                {zone.percentage}%
              </p>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-6 overflow-hidden">
              <div
                className="bg-blue-600 h-6 rounded-full flex items-center justify-center text-white text-sm font-semibold transition-all duration-700 ease-in-out"
                style={{ width: `${zone.percentage}%` }}
              >
                {zone.percentage}%
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Footer Date */}
      <div className="flex justify-end items-center mt-4">
        <p className="text-sm text-gray-700">
           {latestDate}
        </p>
      </div>
    </div>
  );
};

export default NetPayment;
